// api.js

import axiosInstance from "../axiosInstance";

export const purchaseOrderService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post("/purchase-order", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetch: async (query, client, searchValue) => {
    try {
      let api_query = `/purchase-order?`;

      if (client) {
        api_query += `client=${client}`;
      }

      if (searchValue) {
        api_query += `&no=${searchValue}`;
      }

      if (query) {
        api_query += `&${query}`;
      }

      if (!api_query.includes("$sort")) {
        api_query += `&$sort[createdAt]=-1`;
      }

      const response = await axiosInstance.get(api_query);
      return response.data;
    } catch (error) {
      console.error("Error fetching Purchase Orders:", error);
      throw error;
    }
  },

  edit: async (id, data) => {
    try {
      let response = await axiosInstance.patch(`/purchase-order/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/purchase-order/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchMasterPoNo: async (searchKey, client, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client) {
        query += `&client=${client}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }
      let response = await axiosInstance.get(`/fetch-masterpo-no?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
